<template>
  <main class="leaderboard container" v-cloak>
    <!-- <h3 class="c-leaderboard__text">I primi 3 classificati avranno l’occasione di partecipare al Captain’s Run del 13 marzo (ore 14) il giorno prima della partita con l’Inghilterra.</h3> -->
    <section id="podium" class="row d-flex flex-column flex-md-row align-items-md-end" v-cloak>
      <template v-if="leaderboard">
        <div class="place order-1 order-md-2 col-12 col-md-4">
          <div class="step first" v-if="leaderboard[0]">
            <div style="position:relative" class="avatar-with-badge">
              <div class="avatar-container">
                <div class="avatar">
                  <img
                    v-if="leaderboard[0].userId === $store.state.user.id"
                    :src="$store.state.user.profile.avatar"
                    v-cloak
                  />
                </div>
              </div>
              <span class="badge badge-pill badge-secondary">{{$t('1st')}}</span>
            </div>
            <div class="info d-flex flex-row align-items-end">
              <div class="text-center w-100">
                <h2 class="user-name">
                  <span v-cloak>
                    <template v-if="leaderboard[0].first_name !== null">
                      <template
                        v-if="leaderboard[0].userId === $store.state.user.id"
                      >{{ $store.state.user.profile.first_name}} {{ $store.state.user.profile.last_name}}</template>
                      <template v-else>{{ leaderboard[0].first_name }} {{leaderboard[0].last_name}}.</template>
                    </template>
                    <template v-else>{{ $t('User')}}</template>
                  </span>
                </h2>
                <h4 class="user-points">
                  <span v-cloak>{{ leaderboard[0].points}} {{$t('pt')}}</span>
                </h4>
              </div>
            </div>
          </div>
        </div>
        <div class="place order-2 order-md-1 col-12 col-md-4">
          <div class="step second" v-if="leaderboard[1]">
            <div style="position:relative" class="avatar-with-badge">
              <div class="avatar-container">
                <div class="avatar">
                  <img
                    v-if="leaderboard[1].userId === $store.state.user.id"
                    :src="$store.state.user.profile.avatar"
                    v-cloak
                  />
                </div>
              </div>
              <span class="badge badge-pill badge-secondary">{{$t('2nd')}}</span>
            </div>
            <div class="info d-flex flex-row align-items-end">
              <div class="text-center w-100">
                <h2 class="user-name">
                  <span v-cloak>
                    <template v-if="leaderboard[1].first_name !== null">
                      <template
                        v-if="leaderboard[1].userId === $store.state.user.id"
                      >{{ $store.state.user.profile.first_name}} {{ $store.state.user.profile.last_name}}</template>
                      <template v-else>{{ leaderboard[1].first_name }} {{leaderboard[1].last_name}}.</template>
                    </template>
                    <template v-else>{{ $t('User')}}</template>
                  </span>
                </h2>
                <h4 class="user-points">
                  <span v-cloak>{{ leaderboard[1].points }} {{$t('pt')}}</span>
                </h4>
              </div>
            </div>
          </div>
        </div>
        <div class="place order-3 col-12 col-md-4">
          <div class="step third" v-if="leaderboard[2]">
            <div style="position:relative" class="avatar-with-badge">
              <div class="avatar-container">
                <div class="avatar">
                  <img
                    v-if="leaderboard[2].userId === $store.state.user.id"
                    :src="$store.state.user.profile.avatar"
                    v-cloak
                  />
                </div>
              </div>
              <span class="badge badge-pill badge-secondary">{{$t('3rd')}}</span>
            </div>
            <div class="info d-flex flex-row align-items-end">
              <div class="text-center w-100">
                <h2 class="user-name">
                  <span v-cloak>
                    <template v-if="leaderboard[2].first_name !== null">
                      <template
                        v-if="leaderboard[2].userId === $store.state.user.id"
                      >{{ $store.state.user.profile.first_name}} {{ $store.state.user.profile.last_name}}</template>
                      <template v-else>{{ leaderboard[2].first_name }} {{leaderboard[2].last_name}}.</template>
                    </template>
                    <template v-else>{{ $t('User')}}</template>
                  </span>
                </h2>
                <h4 class="user-points">
                  <span v-cloak>{{ leaderboard[2].points }} {{$t('pt')}}</span>
                </h4>
              </div>
            </div>
          </div>
        </div>
      </template>
    </section>
    <section id="board">
      <div class="d-flex flex-column container" v-cloak>
        <template v-if="leaderboard">
          <div
            class="row podium"
            :class="{me:card.userId === $store.state.user.id}"
            v-for="(card, index) in podiumLeaderboard"
            :key="'podium-'+index"
          >
            <div class="card col-12" style="height:100px">
              <div class="card-body p-0 m-0 d-flex flex-column flex-md-row align-items-center">
                <div class="row align-items-center w-100">
                  <div class="col-4 col-md-2 icon">
                    <div class="avatar-with-badge">
                      <div class="avatar-container">
                        <div class="avatar">
                          <img
                            v-if="card.userId === $store.state.user.id"
                            :src="$store.state.user.profile.avatar"
                            v-cloak
                          />
                        </div>
                      </div>
                      <span class="badge badge-pill badge-primary">{{card.position}}</span>
                    </div>
                  </div>
                  <div class="col-8 col-md-7 user">
                    <span v-cloak>
                      <template v-if="card.first_name !== null">
                        <template
                          v-if="card.userId === $store.state.user.id"
                        >{{ $store.state.user.profile.first_name}} {{ $store.state.user.profile.last_name}}</template>
                        <template v-else>{{ card.first_name }} {{card.last_name}}.</template>
                      </template>
                      <template v-else>{{ $t('User')}}</template>
                    </span>
                    <span v-cloak class="d-block d-md-none points">{{ card.points }} {{$t('pt')}}</span>
                  </div>
                  <div class="col-3 d-none d-md-block text-center points">
                    <span v-cloak>{{ card.first_name }} {{$t('pt')}}</span>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <template v-if="userPositionInLeaderboard > 4">
            <div class="row placeholder">
              <div class="card col-12" style="height:100px">
                <div class="card-body p-0 m-0 d-flex flex-column flex-md-row align-items-center">
                  <div class="row align-items-center w-100">
                    <div class="col-4 col-md-2 icon">
                      <div class="avatar-with-badge">
                        <div class="avatar-container">
                          <div class="avatar"></div>
                        </div>
                        <span class="badge badge-pill badge-primary">&nbsp;</span>
                      </div>
                    </div>
                    <div class="col-8 col-md-7 user">
                      <span v-cloak class="ph" style="width:40%">&nbsp;</span>
                      <span
                        v-cloak
                        class="d-block d-md-none points ph"
                        style="width:30%;margin-top:5px"
                      >&nbsp;</span>
                    </div>
                    <div class="col-3 d-none d-md-block text-center points">
                      <span class="ph" style="width: 60%;margin: 0 auto;">&nbsp;</span>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </template>
          <div
            class="row"
            :class="{me:card.userId === $store.state.user.id}"
            v-for="(card, index) in leaderboard.slice(3)"
            :key="index"
          >
            <div class="card col-12" style="height:100px">
              <div class="card-body p-0 m-0 d-flex flex-column flex-md-row align-items-center">
                <div class="row align-items-center w-100">
                  <div class="col-4 col-md-2 icon">
                    <div class="avatar-with-badge">
                      <div class="avatar-container">
                        <div class="avatar">
                          <img
                            v-if="card.userId === $store.state.user.id"
                            :src="$store.state.user.profile.avatar"
                            v-cloak
                          />
                        </div>
                      </div>
                      <span class="badge badge-pill badge-primary">{{card.position}}</span>
                    </div>
                  </div>
                  <div class="col-8 col-md-7 user">
                    <span v-cloak>
                      <template v-if="card.first_name !== null">
                        <template
                          v-if="card.userId === $store.state.user.id"
                        >{{ $store.state.user.profile.first_name}} {{ $store.state.user.profile.last_name}}</template>
                        <template v-else>{{ card.first_name }} {{card.last_name}}.</template>
                      </template>
                      <template v-else>{{ $t('User')}}</template>
                    </span>
                    <span v-cloak class="d-block d-md-none points">{{ card.points }} {{$t('pt')}}</span>
                  </div>
                  <div class="col-3 d-none d-md-block text-center points">
                    <span v-cloak>{{ card.points }} {{$t('pt')}}</span>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="row placeholder">
            <div class="card col-12" style="height:100px">
              <div class="card-body p-0 m-0 d-flex flex-column flex-md-row align-items-center">
                <div class="row align-items-center w-100">
                  <div class="col-4 col-md-2 icon">
                    <div class="avatar-with-badge">
                      <div class="avatar-container">
                        <div class="avatar"></div>
                      </div>
                      <span class="badge badge-pill badge-primary">&nbsp;</span>
                    </div>
                  </div>
                  <div class="col-8 col-md-7 user">
                    <span v-cloak class="ph" style="width:40%">&nbsp;</span>
                    <span
                      v-cloak
                      class="d-block d-md-none points ph"
                      style="width:30%;margin-top:5px"
                    >&nbsp;</span>
                  </div>
                  <div class="col-3 d-none d-md-block text-center points">
                    <span class="ph" style="width: 60%;margin: 0 auto;">&nbsp;</span>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </template>
      </div>
    </section>
  </main>
</template>

<script>
import _ from "lodash";
export default {
  name: "leaderboard",
  data() {
    return {
      leaderboard: []
    };
  },
  created() {
    this.getLeaderboard();
  },
  computed: {
    userPositionInLeaderboard() {
      let position = null;
      _.forEach(this.leaderboard, leaderboardEntry => {
        if (leaderboardEntry.userId === this.$store.state.user.id) {
          position = leaderboardEntry.position;
          return false;
        }
      });

      return position;
    },
    podiumLeaderboard() {
      if(this.leaderboard.length > 3) {
        return this.leaderboard.slice(0,3);
      }

      return this.leaderboard;
    }
  },
  methods: {
    async getLeaderboard() {
      this.$store.commit("showSpinner");
      try {
        let response = await this.$http.get(
          "/api/v1/campaigns/" + this.$store.state.campaign.id + "/leaderboard"
        );
        this.leaderboard = _.get(response, "data.data");
      } catch (e) {
        console.log(e);
        this.$store.commit("pushMessage", {
          type: "error",
          title: "Error",
          text: "An error occurred"
        });
      }
      this.$store.commit("hideSpinner");
    }
  }
};
</script>

<style scoped>
.row.podium {
  display: none;
}
.row.placeholder .avatar-container {
  background: #efefef;
}
.row.placeholder .badge-primary {
  background: #e0e0e0;
}
.row.placeholder .ph {
  display: block;

  background-color: #efefef;
  border-radius: 5px;
}

main.leaderboard #board .row .icon .avatar-with-badge .badge {
  width: auto !important;
}

@media (max-width: 768px) {
  #podium {
    display: none !important;
  }
  .row.podium {
    display: block;
  }
}

@media (min-width: 768px) and (max-width: 991px) {
  main.leaderboard #podium {
    margin-top: 15rem !important;
  }
}

.c-leaderboard__text{
  margin-top: 3rem;
  text-align: center
}
</style>
